export const OLD_PIN_FIELD_NAME = 'data.attributes.oldPin';
export const NEW_PIN_FIELD_NAME = 'data.attributes.newPin';
export const NEW_PIN_CONFIRM_FIELD_NAME = 'new-pin-confirm';

export const PIN_NOT_MATCH_VGS_MESSAGE = 'comparison failed';

export const MAP_VGS_RESET_PIN_ERRORS_TO_ZEN_MESSAGE = {
  'Incorrect or invalid PIN.': {
    title: 'Incorrect PIN',
    description: 'This PIN is invalid. Please try again.'
  }
};
